import PropTypes from 'prop-types';
import React from 'react';

import { organiserFullPropTypeShape } from '../../proptypes';

import Container from '../Container';
import EventList from '../EventList/EventListContainer.react';
import PageHeader from '../PageHeader';

import { header } from './styles.module.css';

/**
 * Organiser detail presentational component.
 */
const OrganiserDetail = ({ description, images, searchQuery, title }) => (
  <div>
    <PageHeader
      title={title}
      description={description}
      logo={images && images.logo && images.logo.thumbnail}
      className={header}
    />
    <Container>
      <EventList query={searchQuery} isReviewPage source="organiser_page" />
    </Container>
  </div>
);

OrganiserDetail.propTypes = {
  /**
   * HTML string description of organiser.
   */
  description: organiserFullPropTypeShape.description,
  /**
   * Object containing image data objects.
   */
  images: organiserFullPropTypeShape.images,
  /**
   * Query object for 'search' query.
   */
  searchQuery: PropTypes.shape(),
  /*
   * String title of the organiser.
   */
  title: organiserFullPropTypeShape.title, // eslint-disable-line react/require-default-props
};

OrganiserDetail.defaultProps = {
  description: undefined,
  images: undefined,
  searchQuery: undefined,
};

export default OrganiserDetail;
